// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__box--j7K2q {
  position: relative;
  height: 100%;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__loader--Bh_cS {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__pads--X4cyP {
  padding: 4px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__tools--Q1Zey {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__tools--Q1Zey .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__toolSpace--MQVh2 {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Summary.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AACF;AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAIA;EACE,iBAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJF;AACA;EAMI,OAAA;AAJJ","sourcesContent":[".box {\n  position: relative;\n  height: 100%;\n  overflow: auto;\n}\n.loader {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(255, 255, 255, 0.5);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n// На макете эти поля для всех экранов. Хотя можно было бы предположить, что конечная таблица могла бы занять всю ширину\n.pads {\n  padding: 4px 24px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  height: 100%;\n  overflow: auto;\n}\n\n.tools {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n\n  .toolSpace {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__box--j7K2q`,
	"loader": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__loader--Bh_cS`,
	"pads": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__pads--X4cyP`,
	"tools": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__tools--Q1Zey`,
	"toolSpace": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Summary-module__toolSpace--MQVh2`
};
export default ___CSS_LOADER_EXPORT___;
